import { cx, Flex } from '@vtex/admin-ui'
import { forwardRef } from 'react'
import { DefaultProps } from 'typings'
import styles from './styles.css'

interface StyledComponent extends DefaultProps {
  className?: string
}

export function TagsList(props: StyledComponent) {
  const { className = '', children } = props

  return (
    <Flex wrap="wrap" className={cx(styles.tagsList, className)} role="list">
      {children}
    </Flex>
  )
}

type Props = React.HTMLAttributes<HTMLDivElement>

export const Tag = forwardRef<HTMLDivElement, Props>(function Tag(props, ref?) {
  const { className = '', children, onClick, ...rest } = props

  return (
    <div
      className={cx(styles.tag, className)}
      data-pp-tag
      data-stop-propagation
      {...rest}
      role="listitem"
      ref={ref}
      onClick={(e) => {
        onClick?.(e)
        e.stopPropagation()
      }}
    >
      {children}
    </div>
  )
})
